<div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 open-value">
  <po-widget>
    <!--<span class="po-font-text-bold title">Valor em aberto por documento</span>-->
    <div class="icon-loading" *ngIf="loading && !errorApi">
      <app-loading-icon></app-loading-icon>
    </div>
    <div *ngIf="!loading && errorApi">
      <app-error [message]="message"></app-error>
    </div>
    <div class="po-table-main-container" *ngIf="!loading && !errorApi">
      <div class="po-table-wrapper" style="opacity: 1">
        <div>
          <div class="po-md-12">
            <div class="po-font-text-bold">Valor em aberto por documento</div>
            <po-table
              [p-columns]="columns"
              [p-infinite-scroll-distance]="80"
              [p-height]="350"
              [p-items]="items"
              [p-striped]="true"
            >
            </po-table>
          </div>
        </div>
      </div>
    </div>
  </po-widget>
</div>